import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
  // getUserConfirmation: (message, callback) => {
  //   const allowTransition = window.confirm(message);
  //   window.setTimeout(() => {
  //     callback(allowTransition);
  //   }, 1000);
  // },
});

export default history;

